import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableLayout, TableLayoutType, TableRow, TextRun, VerticalAlign, WidthType } from "docx";


export const team = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    layout: TableLayoutType.FIXED,
    spacing: { before: 600 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 7, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Name",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 15, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Designation",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 30, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Email Id",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 16, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Professional Qualifications/ Certifications ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 18, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 100 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Whether the resource has been listed in the Snapshot information published on CERT-In’s website (Yes/No) ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Sachin Kumar S",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Senior Security Analyst",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "   ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "CEH",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Yes",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Aghilesh B",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Senior Security Analyst",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "   ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Yes",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
    ]
})
